// @ts-nocheck
import msalInstance from "./authConfig";

export function getAuth() {
  try {
    // If we've previously persisted a minimal auth object, prefer it when claims are missing
    try {
      const persistedAuth = localStorage.getItem("auth");
      if (persistedAuth) {
        const parsed = JSON.parse(persistedAuth || "{}");
        if (parsed && parsed.id) {
          const num = parseInt(String(parsed.id).replace(/[^0-9-]/g, ""), 10);
          return {
            id: !isNaN(num) ? num : parsed.id,
            username: parsed.username || null,
            claims: {},
            tag: parsed.tag,
          };
        }
      }
    } catch (e) {}
    // fallback: previously persisted employeeId
    try {
      const persisted = localStorage.getItem("employeeId");
      if (persisted) {
        const num = parseInt(persisted, 10);
        if (!isNaN(num)) return { id: num, username: null, claims: {} };
      }
    } catch (e) {}
    const accounts = msalInstance.getAllAccounts();
    if (!accounts || accounts.length === 0) return null;
    const acct = accounts[0];
    const claims = acct.idTokenClaims || {};
    // recursively search claims for employee id-like keys
    function findEmployeeId(obj) {
      if (!obj || typeof obj !== "object") return undefined;
      const keys = Object.keys(obj);
      for (const k of keys) {
        const lower = k.toLowerCase();
        if (
          lower === "employeeid" ||
          lower === "employee_id" ||
          lower === "employeeidnumber" ||
          (lower.includes("employee") && lower.includes("id")) ||
          (lower.startsWith("extension_") &&
            lower.toLowerCase().includes("employee"))
        ) {
          return obj[k];
        }
      }
      // deeper search
      for (const k of keys) {
        try {
          const val = obj[k];
          if (typeof val === "object") {
            const found = findEmployeeId(val);
            if (found !== undefined) return found;
          }
        } catch (e) {
          continue;
        }
      }
      return undefined;
    }

    // recursively search claims for department (tag) keys
    function findDepartment(obj) {
      if (!obj || typeof obj !== "object") return undefined;
      const keys = Object.keys(obj);
      for (const k of keys) {
        const lower = k.toLowerCase();
        if (
          lower === "department" ||
          lower === "dept" ||
          lower === "jobinformation" ||
          lower.includes("department") ||
          lower.includes("dept")
        ) {
          return obj[k];
        }
      }
      for (const k of keys) {
        try {
          const val = obj[k];
          if (typeof val === "object") {
            const found = findDepartment(val);
            if (found !== undefined) return found;
          }
        } catch (e) {
          continue;
        }
      }
      return undefined;
    }

    let id = findEmployeeId(claims);
    if (id === undefined || id === null) {
      id = acct.username || acct.homeAccountId || acct.localAccountId;
    }

    // coerce numeric employee id to a number when possible
    let numericId = null;
    if (id !== undefined && id !== null) {
      const parsed = parseInt(String(id).replace(/[^0-9-]/g, ""), 10);
      if (!isNaN(parsed)) numericId = parsed;
    }

    // find department/tag
    let tag = findDepartment(claims);
    if (tag === undefined || tag === null) {
      // try common claim keys
      tag =
        claims.tag || claims.department || claims.dept || claims.departmentName;
    }
    // normalize tag to string when present
    if (tag !== undefined && tag !== null) tag = String(tag);

    const finalId = numericId !== null ? numericId : id;
    // persist minimal auth for backward compatibility
    try {
      const minimal = { id: finalId, username: acct.username || null, tag };
      localStorage.setItem("auth", JSON.stringify(minimal));
    } catch (e) {}

    // If tag is missing, try a non-blocking Graph call to /me to fetch department and persist it.
    if ((!tag || String(tag).trim() === "") && acct) {
      (async () => {
        try {
          const resp = await msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account: acct,
          });
          const accessToken = resp && resp.accessToken;
          if (!accessToken) return;
          const r = await fetch(
            "https://graph.microsoft.com/v1.0/me?$select=department,displayName,mail",
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            },
          );
          if (!r.ok) return;
          const profile = await r.json();
          const dept =
            profile &&
            (profile.department || profile.jobTitle || profile.officeLocation);
          if (dept) {
            const minimal = {
              id: finalId,
              username: acct.username || profile.mail || null,
              tag: String(dept),
            };
            try {
              localStorage.setItem("auth", JSON.stringify(minimal));
            } catch (e) {}
          }
        } catch (e) {
          // ignore errors (silent acquire may require interaction)
        }
      })();
    }

    return { id: finalId, username: acct.username, claims, tag, account: acct };
  } catch (e) {
    return null;
  }
}

export default getAuth;
